export const TAG = 'tag'

export const initialValues = {
  [TAG]: ''
}
